import { BaseQueryFn, createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery, AxiosBaseQueryParams } from "@admin/utils/axios-utils";
import { BASE_URL } from "@admin/utils/constants";

// Base Api for all endpoints
const baseQuery = axiosBaseQuery({
  baseUrl: BASE_URL,
});

const baseQueryExtension: BaseQueryFn<AxiosBaseQueryParams | string> = async (
  args,
  api,
  extraOptions
) => {
  let result = await baseQuery(
    typeof args === "string"
      ? {
          url: args,
          method: "GET",
        }
      : args,
    api,
    extraOptions
  );
  if (result.error && result.error.status === 401) {
    window.location.assign(
      `/login?message=Authentication required. Please, sign in to continue!&next=${window.location.href}`
    );
  }
  return result;
};

export default createApi({
  baseQuery: baseQueryExtension,
  reducerPath: "api",
  keepUnusedDataFor: 5 * 60,
  tagTypes: ["category", "color", "tag", "page", "ingredient"],
  endpoints: () => ({}),
});
